import { combineEpics } from 'redux-observable';

import fetchMemberDetailsEpic from './epics/fetchMemberDetails';

export default combineEpics(fetchMemberDetailsEpic);
